/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Type of the Media Alignment
 */
export let MEDIA_ALIGNMENT;

/**
 * Type of color scheme
 */
(function (MEDIA_ALIGNMENT) {
  MEDIA_ALIGNMENT["RIGHT"] = "right";
  MEDIA_ALIGNMENT["LEFT"] = "left";
})(MEDIA_ALIGNMENT || (MEDIA_ALIGNMENT = {}));
export let COLOR_SCHEME;
(function (COLOR_SCHEME) {
  COLOR_SCHEME["REGULAR"] = "regular";
  COLOR_SCHEME["INVERSE"] = "inverse";
  COLOR_SCHEME["CYAN"] = "cyan";
  COLOR_SCHEME["PURPLE"] = "purple";
})(COLOR_SCHEME || (COLOR_SCHEME = {}));
//# sourceMappingURL=defs.js.map
